import { render, staticRenderFns } from "./AddProjectStep2.vue?vue&type=template&id=9b07c26e&"
import script from "./AddProjectStep2.vue?vue&type=script&lang=js&"
export * from "./AddProjectStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports